import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './Aside.module.scss'

const Aside = () => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  return (
    <>
      {!viewport.mobile && (
        <aside className={style.aside}>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'ecommerce', 'categories')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'ecommerce', 'saleOffers')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'ecommerce', 'shopByPrice')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'ecommerce', 'bestSellers')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'ecommerce', 'bestFor')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'ecommerce', 'customerRating')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'ecommerce', 'gifting')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'ecommerce', 'cashbackDeals')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'ecommerce', 'fastestDelivery')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
        </aside>
      )}
    </>
  )
}
export default Aside
